import * as React from "react";

function ArrowRight(props) {
  return <svg viewBox="0 0 24 24" fill="none" {...props}><path d="M15.5 7.5L20 12m0 0l-4.5 4.5M20 12H4" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" /></svg>;
}

export default ArrowRight;